/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InstallDbResponseType { 
    /**
     * Case ID of Install/Uninstall case, if applicable.
     */
    case_id?: string;
    /**
     * Any additional text response for user
     */
    message?: string;
    /**
     * Success/Failure of API call
     */
    status?: boolean;
}

